import { ApiEndPoints, NetworkManager } from "../network";

export class PatientServices {
    
    static getAllPatients = (page = 0, size = 10) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patients}/all?page=${page}&size=${size}`,
        });
    };

    static getPatientsByTaluk = (talukId, page = 0, size = 10) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patients}/taluk/${talukId}?page=${page}&size=${size}`,
        });
    };

    static getPatientsByPhc = (phcId, page = 0, size = 10) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patients}/phc/${phcId}?page=${page}&size=${size}`,
        });
    };

    static getPatientsByAsha = (ashaId, page = 0, size = 10) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patients}/asha/${ashaId}?page=${page}&size=${size}`,
        });
    };

    static getPatientsByAshaBlock = (ashaBlockId, page = 0, size = 10) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patients}/ashablock/${ashaBlockId}?page=${page}&size=${size}`,
        });
    };

    static async getPatientsByHospital(hospitalId, pdType, page = 0, size = 10) {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patients}/hospital/${hospitalId}?pdType=${pdType}&page=${page}&size=${size}`,
        });
    }

    static async getPatientDetails(patientId) {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.getPatientDetails}/${patientId}`,
        });
    }

    
    static getAllPatientsByPhc = (phcId) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patients}/listByPhcAndStatus/${phcId}`,
        });
    };

    static updatePatientCataractDetails = (data) => {
        return NetworkManager.getInstance().appRequest({
            method: "put",
            url: `${ApiEndPoints.patientCataractDetails}/update`,
            data: data,
        });
    };

    static createPatientCataractDetails = (data) => {
        return NetworkManager.getInstance().appRequest({
            method: "post",
            url: `${ApiEndPoints.patientCataractDetails}/create`,
            data: data,
        });
    };

    static getPatientCataractDetailsByPatientId = (patientId) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patientCataractDetails}/patient/${patientId}`,
        });
    };

    // Glaucoma Details API methods
    static createPatientGlaucomaDetails = (data) => {
        return NetworkManager.getInstance().appRequest({
            method: "post",
            url: `${ApiEndPoints.patientGlaucomaDetails}/create`,
            data: data,
        });
    };

    static updatePatientGlaucomaDetails = (data) => {
        return NetworkManager.getInstance().appRequest({
            method: "put",
            url: `${ApiEndPoints.patientGlaucomaDetails}/update`,
            data: data,
        });
    };

    static getPatientGlaucomaDetailsByPatientId = (patientId) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patientGlaucomaDetails}/patient/${patientId}`,
        });
    };

    // Diabetic Retinopathy Details API methods
    static updatePatientDiabeticRetinopathyDetails = (data) => {
        return NetworkManager.getInstance().appRequest({
            method: "post",
            url: `${ApiEndPoints.patientDiabeticRetinopathyDetails}/create`,
            data: data,
        });
    };

    static getPatientDiabeticRetinopathyDetailsByPatientId = (patientId) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patientDiabeticRetinopathyDetails}/patient/${patientId}`,
        });
    };

    // Cataract Follow-up Details API methods
    static getCataractFollowUpDetails = (cataractDetailsId) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patientCataractDetails}/followup/${cataractDetailsId}`,
        });
    };

    static createCataractFollowUp = (data) => {
        return NetworkManager.getInstance().appRequest({
            method: "post",
            url: `${ApiEndPoints.patientCataractDetails}/followup/create`,
            data: data,
        });
    };

    // Glaucoma Follow-up Details API methods
    static getGlaucomaFollowUpDetails = (glaucomaDetailsId) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patientGlaucomaDetails}/followup/${glaucomaDetailsId}`,
        });
    };

    static createGlaucomaFollowUp = (data) => {
        return NetworkManager.getInstance().appRequest({
            method: "post",
            url: `${ApiEndPoints.patientGlaucomaDetails}/followup/create`,
            data: data,
        });
    };

    // Followup Places API method
    static getFollowupPlaces = () => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.followupPlaces}`,
        });
    };

    // DR Follow-up API methods
    static getDrFollowUpDetailsByDrId = (drId) => {
        return NetworkManager.getInstance().appRequest({
            method: "get",
            url: `${ApiEndPoints.patientDiabeticRetinopathyDetails}/followup/${drId}`,
        });
    };
}